var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-header-index-wide transparent-area-appear" },
    [
      _c(
        "a-row",
        { attrs: { span: 24 } },
        [
          _c(
            "a-card",
            { attrs: { loading: _vm.loading, bordered: false } },
            [
              _c(
                "a-row",
                { staticClass: "row-box", attrs: { gutter: [15, 15] } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 4, lg: 7, md: 9, sm: 24 } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择年级",
                          dictCode:
                            "school_grade,grade_name,id,0=delete_flag order by sort_order",
                          allowClear: "",
                        },
                        model: {
                          value: _vm.queryParam.gradeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "gradeId", $$v)
                          },
                          expression: "queryParam.gradeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 4, lg: 6, md: 9, sm: 24 } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择班级",
                          dictCode:
                            "school_class,name,id,grade_id=" +
                            (!_vm.queryParam.gradeId
                              ? -1
                              : _vm.queryParam.gradeId),
                          async: true,
                        },
                        model: {
                          value: _vm.queryParam.classId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParam, "classId", $$v)
                          },
                          expression: "queryParam.classId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 4, lg: 6, md: 9, sm: 24 } },
                    [
                      _c("a-range-picker", {
                        staticStyle: { width: "100%" },
                        attrs: { value: _vm.rangeDate },
                        on: { change: _vm.onRangeChange },
                      }),
                    ],
                    1
                  ),
                  _vm._l(_vm.searchItem, function (item, index) {
                    return _c(
                      "a-col",
                      { key: item, staticClass: "tag-col", attrs: { span: 2 } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tag-item",
                            style: {
                              borderLeft: `4px solid ${_vm.searchItemColor[index]}`,
                            },
                          },
                          [
                            _c("span", { staticClass: "tag-name" }, [
                              _vm._v(_vm._s(item)),
                            ]),
                            _c("a-icon", {
                              staticClass: "delete-icon",
                              attrs: { type: "close-circle" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteBtn(item, index)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  _vm.contrastInputStatus
                    ? _c(
                        "a-col",
                        { staticClass: "select-box", attrs: { span: 3 } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "show-search": "",
                                value: _vm.context2,
                                "default-active-first-option": false,
                                "show-arrow": false,
                                "filter-option": false,
                                "not-found-content": null,
                              },
                              on: {
                                focus: _vm.handleSearch,
                                search: _vm.handleSearch,
                                change: _vm.handleChange,
                                select: _vm.handleSelect,
                                inputKeydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return (() => {
                                    _vm.contrastInputStatus = false
                                  }).apply(null, arguments)
                                },
                              },
                            },
                            _vm._l(_vm.keyword, function (d) {
                              return _c(
                                "a-select-option",
                                { key: d.period_id },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(d.name) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _c("a-icon", {
                            staticClass: "select-del-icon",
                            attrs: { type: "close-circle" },
                            on: {
                              click: () => {
                                _vm.contrastInputStatus = false
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("a-col", { attrs: { span: 3 } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-right": "10px" },
                            on: { click: _vm.addContrast },
                          },
                          [_vm._v(" + 添加对比 ")]
                        ),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.chaDate },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-row",
        [
          _c(
            "a-col",
            {
              staticClass: "line-title",
              style: { marginLeft: "24px" },
              attrs: { span: 24 },
            },
            _vm._l(_vm.schoolEmotionsTitle, function (item, index) {
              return _c("span", { key: index }, [
                _c(
                  "span",
                  {
                    class: {
                      primaryColor:
                        index === _vm.schoolEmotionsTitle.length - 1 &&
                        _vm.schoolEmotionsTitle.length > 1,
                    },
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.fallback(index)
                      },
                    },
                  },
                  [_vm._v("\n              " + _vm._s(item) + "\n          ")]
                ),
                _vm.schoolEmotionsTitle.length - 1 != index
                  ? _c("span", [_vm._v(" > ")])
                  : _vm._e(),
              ])
            }),
            0
          ),
          _c(
            "a-col",
            { attrs: { span: 24 } },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 17 } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "leftCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "salesCard" },
                                    [
                                      _c(
                                        "LineChart",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "20px",
                                          },
                                          attrs: {
                                            title: `${_vm.currentLineTitle}心情变化趋势`,
                                            height: "250px",
                                            fields: _vm.moodField,
                                            dataSource: _vm.schoolMood,
                                          },
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "titleExtra" },
                                            [
                                              _c(
                                                "a-button",
                                                {
                                                  staticClass: "add-btn",
                                                  attrs: { type: "primary" },
                                                  on: {
                                                    click: _vm.addEventClick,
                                                  },
                                                },
                                                [_vm._v("添加事件")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "leftCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "salesCard" },
                                    [
                                      _c("LineChart", {
                                        staticStyle: {
                                          "margin-bottom": "20px",
                                        },
                                        attrs: {
                                          title: `${_vm.currentLineTitle}心情波动指数趋势`,
                                          height: "250px",
                                          fields: _vm.volatilityIndex,
                                          dataSource: _vm.schoolMoodSwings,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "leftCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "salesCard" },
                                    [
                                      _c(
                                        "a-row",
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c("LineChart", {
                                                staticStyle: {
                                                  "margin-bottom": "20px",
                                                },
                                                attrs: {
                                                  title: "学生活跃度对比",
                                                  grid: _vm.grid,
                                                  height: "250px",
                                                  fields: ["学生活跃度"],
                                                  dataSource:
                                                    _vm.studentActivity,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c("LineChart", {
                                                staticStyle: {
                                                  "margin-bottom": "20px",
                                                },
                                                attrs: {
                                                  title: "家长关注度对比",
                                                  grid: _vm.grid,
                                                  height: "250px",
                                                  fields: ["家长活跃度"],
                                                  dataSource: _vm.parentVisit,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "a-row",
                        [
                          _c(
                            "a-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentLineTitle !== "班级",
                                  expression: "currentLineTitle !== '班级'",
                                },
                              ],
                              attrs: { span: 24 },
                            },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "RightCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c("TableList", {
                                    attrs: {
                                      title: _vm.gradeEmotions.title,
                                      columns: _vm.gradeEmotions.columns,
                                      tableData: _vm.gradeEmotions.tableData,
                                    },
                                    on: {
                                      addContrast: (record) =>
                                        _vm.addContrastCell(1, record),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "RightCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c("TableList", {
                                    attrs: {
                                      title: _vm.classEmotions.title,
                                      columns: _vm.classEmotions.columns,
                                      tableData: _vm.classEmotions.tableData,
                                    },
                                    on: {
                                      chartClick: (title, record) =>
                                        _vm.chartClick(title, record, 2),
                                      addContrast: (record) =>
                                        _vm.addContrastCell(2, record),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "RightCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c("TableList", {
                                    attrs: {
                                      title: _vm.teacherUseList.title,
                                      columns: _vm.teacherUseList.columns,
                                      tableData: _vm.teacherUseList.tableData,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "teacherlRemind",
                                        fn: function (slotProps) {
                                          return [
                                            _c(
                                              "a-popconfirm",
                                              {
                                                attrs: {
                                                  title: "确定要提醒吗？",
                                                  "ok-text": "确认",
                                                  "cancel-text": "取消",
                                                },
                                                on: {
                                                  confirm: function ($event) {
                                                    return _vm.teacherRemindList(
                                                      slotProps
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#86a3e5",
                                                      cursor: "pointer",
                                                    },
                                                  },
                                                  [_vm._v("提醒")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "RightCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c("TableList", {
                                    attrs: {
                                      title: _vm.recentMoodLowList.title,
                                      columns: _vm.recentMoodLowList.columns,
                                      tableData:
                                        _vm.recentMoodLowList.tableData,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "recentMoodLow",
                                        fn: function ({ record }) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#86a3e5",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.viewUnhappyStudent(
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-card",
                                {
                                  staticClass: "RightCardBox",
                                  style: { marginBottom: "24px" },
                                  attrs: {
                                    loading: _vm.loading,
                                    bordered: false,
                                  },
                                },
                                [
                                  _c("TableList", {
                                    attrs: {
                                      title: _vm.mainCareList.title,
                                      columns: _vm.mainCareList.columns,
                                      tableData: _vm.mainCareList.tableData,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "emotionalTrends",
                                        fn: function (slotProps) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#86a3e5",
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.viewCareList(
                                                      slotProps,
                                                      2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看")]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.currentLineTitle == "班级"
                            ? _c(
                                "a-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "a-card",
                                    {
                                      staticClass: "RightCardBox",
                                      style: { marginBottom: "24px" },
                                      attrs: {
                                        loading: _vm.loading,
                                        bordered: false,
                                      },
                                    },
                                    [
                                      _c("TableList", {
                                        attrs: {
                                          title: _vm.parentFollowList.title,
                                          columns: _vm.parentFollowList.columns,
                                          tableData:
                                            _vm.parentFollowList.tableData,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "phoneEmail",
                                              fn: function ({ record }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        color: "#1783EC",
                                                        "text-align": "center",
                                                        "font-weight": "bold",
                                                        cursor: "pointer",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.getParentPhone(
                                                                record
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("手机")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticStyle: {
                                                            flex: "1",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.getParentEmail(
                                                                record
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("邮箱")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4279757179
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("AddEventModal", {
        ref: "addEventModal",
        on: { refresh: _vm.refreshMarked },
      }),
      _c("ViewKeyPointModal", { ref: "viewKeyPointModal" }),
      _c("PhoneDetailModal", { ref: "phoneDetailModal" }),
      _c("EmailDetailModal", { ref: "emailDetailModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }